import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff8affac"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 리드엔젤 성과보수 안내 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 거래 성사시 판매금에서 성과보수가 자동 지급된 후")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 나머지 금액이 입금됩니다. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 최초구매 주당 가격 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 판매 예정 주당 가격 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 판매 수익 금액 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 원 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 리드엔젤 성과보수 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 지급예정 성과보수 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 원 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_box = _resolveComponent("ag-box")!

  return (_openBlock(), _createBlock(_component_ag_box, { "text-align": "center" }, {
    default: _withCtx(() => [
      _createVNode(_component_ag_box, {
        dp: "flex",
        "justify-content": "center",
        "margin-bottom": "8px",
        "align-items": "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text, {
            "margin-right": "8px",
            typography: "tit22b",
            color: "black"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_text, {
        typography: "'main14r'",
        dp: "block",
        "text-align": "center",
        "margin-bottom": "8px",
        color: "gray3"
      }),
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_ag_box, {
        "margin-top": "40px",
        style: {"border-bottom":"1px solid #F9F9FB"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_box, {
            dp: "flex",
            "justify-content": "space-between",
            "margin-bottom": "16px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_text, {
                typography: "main14r",
                dp: "block",
                color: "gray3"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_text, {
                    color: "black",
                    typography: "num14bk"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.dealInfo.firstPrice)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_text, {
                    color: "black",
                    typography: "main14r"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ag_box, {
            dp: "flex",
            "justify-content": "space-between",
            "margin-bottom": "16px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_text, {
                typography: "main14r",
                dp: "block",
                color: "gray3"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_text, {
                    color: "black",
                    typography: "num14bk"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.expectedPriceRef)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_text, {
                    color: "black",
                    typography: "main14r"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ag_box, {
            dp: "flex",
            "justify-content": "space-between",
            "margin-bottom": "16px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_text, {
                typography: "main14r",
                dp: "block",
                color: "gray3"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_text, {
                    color: "black",
                    typography: "num14bk"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$filters.currency(_ctx.revenueRef)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ag_text, {
                    color: "black",
                    typography: "main14r"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ag_box, {
            dp: "flex",
            "justify-content": "space-between",
            "margin-bottom": "16px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ag_text, {
                typography: "main14r",
                dp: "block",
                color: "gray3"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_component_ag_box, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ag_text, {
                    color: "black",
                    typography: "main14r"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.incomeFeeRef ? `수익의 ${_ctx.incomeFeeRef}%` : '없음'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ag_box, {
        dp: "flex",
        "justify-content": "space-between",
        my: "16px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_text, { typography: "tit16b" }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_ag_box, null, {
            default: _withCtx(() => [
              _createVNode(_component_ag_text, {
                color: "primary",
                typography: "tit24b"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.carriedInterestRef ? _ctx.$filters.currency(_ctx.carriedInterestRef) : '0'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ag_text, {
                color: "primary",
                style: {"font-size":"24px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}